import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6278c1ee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6278c1ee')) {
      api.createRecord('6278c1ee', component.options)
    } else {
      api.reload('6278c1ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6278c1ee", function () {
      api.rerender('6278c1ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Suppliers/Decorations/index.vue"
export default component.exports